import get from 'lodash/fp/get'

export const getLocale = get('locale')
